'use strict';

// src/render/renderer.ts
var createRenderer = (translate) => {
  const docResolverMap = {
    ["doc:new" /* NEW */]({ notification, sender, owner }) {
      return {
        icon: "tabler:file-plus",
        title: translate("notifications.doc.new.title"),
        description: translate("notifications.doc.new.description", {
          sender: sender == null ? void 0 : sender.name,
          title: notification.data.title
        })
      };
    },
    ["doc:shared" /* SHARED */]({ notification, sender, owner }) {
      return {
        icon: "tabler:file-symlink",
        title: translate("notifications.doc.shared.title"),
        description: translate("notifications.doc.shared.description", {
          sender: sender == null ? void 0 : sender.name,
          title: notification.data.title
        })
      };
    },
    ["doc:comment" /* NEW_COMMENT */]({ notification, sender, owner }) {
      return {
        icon: "tabler:message-dots",
        title: translate("notifications.doc.new_comment.title"),
        description: translate("notifications.doc.new_comment.description", {
          sender: sender == null ? void 0 : sender.name
        })
      };
    },
    ["doc:update" /* UPDATE */]({ notification, sender, owner }) {
      return {
        icon: "tabler:edit",
        title: translate("notifications.doc.update.title"),
        description: translate("notifications.doc.update.description", {
          sender: sender == null ? void 0 : sender.name,
          title: notification.data.title
        })
      };
    },
    ["doc:delete" /* DELETE */]({ notification, sender, owner }) {
      return {
        icon: "tabler:file-off",
        title: translate("notifications.doc.delete.title"),
        description: translate("notifications.doc.delete.description", {
          sender: sender == null ? void 0 : sender.name,
          title: notification.data.title
        })
      };
    }
  };
  const driveResolverMap = {
    ["drive:shared" /* SHARED */]({ notification, sender }) {
      return {
        icon: "tabler:file-import",
        title: translate("notifications.drive.shared.title"),
        description: translate("notifications.drive.shared.description", {
          sender: sender == null ? void 0 : sender.name,
          name: notification.data.name
        })
      };
    }
  };
  const channelMap = {
    ["channel:new" /* NEW */]({ notification, sender }) {
      return {
        icon: "tabler:message-2-plus",
        title: translate("notifications.channel.new.title"),
        description: translate("notifications.channel.new.description", {
          sender: sender == null ? void 0 : sender.name,
          name: notification.data.name
        })
      };
    },
    ["channel:update" /* UPDATE */]({ notification, sender }) {
      return {
        icon: "tabler:message-2-cog",
        title: translate("notifications.channel.update.title"),
        description: translate("notifications.channel.update.description", {
          sender: sender == null ? void 0 : sender.name,
          name: notification.data.name
        })
      };
    },
    ["channel:shared" /* SHARED */]({ notification, sender }) {
      return {
        icon: "tabler:message-2-share",
        title: translate("notifications.channel.shared.title"),
        description: translate("notifications.channel.shared.description", {
          sender: sender == null ? void 0 : sender.name,
          name: notification.data.name
        })
      };
    },
    ["channel:delete" /* DELETE */]({ notification, sender }) {
      return {
        icon: "tabler:user-minus",
        title: translate("notifications.channel.delete.title"),
        description: translate("notifications.channel.delete.description", {
          sender: sender == null ? void 0 : sender.name,
          name: notification.data.name
        })
      };
    }
  };
  const channelMessageMap = {
    ["channel:message:new" /* NEW */]({ notification, sender }) {
      const { channelType, contentType, content } = notification.data;
      const title = channelType === "p2p" ? translate("notifications.message.dm_title", {
        sender: sender == null ? void 0 : sender.name
      }) : translate("notifications.message.channel_title", {
        sender: sender == null ? void 0 : sender.name,
        channelName: notification.data.channelName
      });
      if (contentType === "text") {
        return {
          icon: "tabler:message",
          title,
          description: content
        };
      }
      if (contentType === "image") {
        return {
          icon: "tabler:photo",
          title,
          description: translate("notifications.message.image_description")
        };
      }
      if (contentType === "audio") {
        return {
          icon: "tabler:speakerphone",
          title,
          description: translate("notifications.message.audio_description")
        };
      }
      return {
        icon: "tabler:message-plus",
        title,
        description: translate("notifications.message.new_message")
      };
    },
    ["channel:message:update" /* UPDATE */]({ notification, sender }) {
      return {
        icon: "tabler:message-exclamation",
        title: translate("notifications.message.update.title"),
        description: translate("notifications.message.update.description", {
          sender: sender == null ? void 0 : sender.name
        })
      };
    },
    ["channel:message:delete" /* DELETE */]({ notification, sender }) {
      return {
        icon: "tabler:message-off",
        title: translate("notifications.message.delete.title"),
        description: translate("notifications.message.delete.description", {
          sender: sender == null ? void 0 : sender.name
        })
      };
    }
  };
  const channelVoiceMap = {
    ["voiceChannel:notes:ready" /* NOTES_READY */]({ notification, sender }) {
      return {
        icon: "tabler:notes",
        title: translate("notifications.voice.notes_ready.title"),
        description: translate("notifications.voice.notes_ready.description", {
          name: notification.data.name
        })
      };
    },
    ["voiceChannel:call:incoming" /* INCOMING_CALL */]({ notification, sender }) {
      return {
        icon: "tabler:phone-call",
        title: translate("notifications.voice.incoming_call.title"),
        description: translate(
          "notifications.voice.incoming_call.description",
          {
            sender: notification.data.sender,
            name: notification.data.name
          }
        )
      };
    }
  };
  const aiScheduleMap = {
    ["aiSchedule:call:incoming" /* INCOMING_CALL */]({ notification, sender }) {
      return {
        icon: "tabler:phone-call",
        title: translate("notifications.ai.incoming_call.title"),
        description: translate("notifications.ai.incoming_call.description", {
          name: notification.data.name
        })
      };
    }
  };
  const meetMap = {
    ["meet:shared" /* SHARED */]({ notification, sender }) {
      return {
        icon: "material-symbols-light:smb-share-sharp",
        title: translate("notifications.meet.shared.title"),
        description: translate("notifications.meet.shared.description", {
          sender: sender == null ? void 0 : sender.name,
          name: notification.data.name
        })
      };
    },
    ["meet:reminder" /* REMINDER */]({ notification, sender }) {
      return {
        icon: "material-icons:note-add",
        title: translate("notifications.meet.reminder.title"),
        description: translate("notifications.meet.reminder.description", {
          name: notification.data.name
        })
      };
    }
  };
  const todoResolverMap = {
    ["todo:shared" /* SHARED */]({ notification, sender }) {
      return {
        icon: "tabler:circle-check",
        title: translate("notifications.todo.shared.title"),
        description: translate("notifications.todo.shared.description", {
          sender: sender == null ? void 0 : sender.name,
          title: notification.data.title
        })
      };
    },
    ["todo:completed" /* COMPLETED */]({ notification, sender }) {
      return {
        icon: "tabler:circle-check",
        title: translate("notifications.todo.completed.title"),
        description: translate("notifications.todo.completed.description", {
          sender: sender == null ? void 0 : sender.name,
          title: notification.data.title
        })
      };
    }
  };
  const workspaceMap = {
    ["workspace:new:user" /* NEW_USER */]({ notification, sender }) {
      return {
        icon: "tabler:user-plus",
        title: translate("notifications.workspace.new_user.title"),
        description: translate("notifications.workspace.new_user.description", {
          sender: sender == null ? void 0 : sender.name
        })
      };
    }
  };
  const boardMap = {
    ["board:shared" /* SHARED */]({ notification, sender }) {
      return {
        icon: "tabler:table-share",
        title: translate("notifications.board.shared.title"),
        description: translate("notifications.board.shared.description", {
          sender: sender == null ? void 0 : sender.name,
          name: notification.data.name
        })
      };
    },
    ["board:edited" /* EDITED */]({ notification, sender }) {
      return {
        icon: "tabler:table-row",
        title: translate("notifications.board.edited.title"),
        description: translate("notifications.board.edited.description", {
          sender: sender == null ? void 0 : sender.name,
          name: notification.data.name
        })
      };
    }
  };
  const boardRowMap = {
    ["board:row:assigned" /* ASSIGNED */]({ notification, sender }) {
      return {
        icon: "tabler:table-row",
        title: translate("notifications.board_row.assigned.title"),
        description: translate("notifications.board_row.assigned.description", {
          sender: sender == null ? void 0 : sender.name,
          columnlabel: notification.data.columnlabel
        })
      };
    },
    ["board:row:comment:new" /* NEW_COMMENT */]({ notification, sender }) {
      return {
        icon: "tabler:message-dots",
        title: translate("notifications.board_row.new_comment.title"),
        description: translate(
          "notifications.board_row.new_comment.description",
          {
            sender: sender == null ? void 0 : sender.name
          }
        )
      };
    }
  };
  return {
    ...meetMap,
    ...boardMap,
    ...channelMap,
    ...boardRowMap,
    ...workspaceMap,
    ...docResolverMap,
    ...channelVoiceMap,
    ...aiScheduleMap,
    ...todoResolverMap,
    ...driveResolverMap,
    ...channelMessageMap
  };
};

// src/render/render.ts
var render = (data, translate) => {
  const { notification } = data;
  const renderer = createRenderer(translate);
  const renderFn = renderer[notification.type];
  if (!renderFn) {
    throw new Error(
      `Renderer not found for notification type: ${notification.type}`
    );
  }
  return renderFn(data);
};

exports.render = render;
